export default __webpack_public_path__ + "static/media/544.52624f49.png";